module.exports = __webpack_public_path__ + "img/touchback_left.93610667.jpg";